import Vue from 'vue';
import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { formatDateTimeSeconds, WindowType } from '../../util';
import { Media } from "../activitymodal/activitymodal.model";

declare var window: WindowType;

/// Imageviewer used in map, works with prop and watcher, see https://johnpapa.net/vue-typescript/ (full example)
@Component(
    {
        name: 'imageviewer',
        components: {// no compoenents used yet
        }
    })
export default class ImageViewerComponent extends Vue {
    @Prop({ required: true })
    readonly medias!: Media[] | undefined;
    @Prop({ default: false })
    readonly isShowDelete!: boolean; // shows the delete trash bin depending on permission

    private PermissionDelete: boolean = false;
    private listView = true;
    private galleryView = false;

    private formatDateTimeSeconds = formatDateTimeSeconds;

    mounted(): void {
        console.log("show delete = " + this.isShowDelete);
        if (this.isShowDelete !== undefined && this.isShowDelete == true) // show delete only if selected
            this.PermissionDelete = window.application.permissions.media.delete;
    }

    //mapper
    private getThumbnailUrl(item) {
        //console.log("--------------->getThumbnailUrl <---------------- " );
        return window.application.baseUrl + "manager/api/media/url/" + item.id + "/210/160";
    }

    //getter
    private get items(): Media[] {
        if (!this.medias) {
            return [];
        }

        this.medias.forEach(media => {
            console.log("file id " + media.id + " uri=" + media.uri + " type=" + media.type);
            media.sizePrettyPrint = media.size > 0 ? (~~(media.size / 1024)).toString(10) + " KB" : "0";
        });
        return this.medias;
    }

    private openItem(item: Media): void {
        //window.application.preview module
        console.log("openItem item id=" + item.id)
        window.application.preview.open(item.id);
    }

    private remove(itemId): void {
        var self = this;
        fetch(window.application.baseUrl + "manager/api/media/delete/" + itemId)
            .then(function (response) { return response.json(); })
            .then(function (result) {
                // Push status to notification hub  //NOTRMARK
                console.log(" Deleted");
                self.$emit('removed-media', itemId);
                self.refreshBase();
            })
            .catch(function (error) { console.log("error:", error); });
        console.log(" Deleted");
        self.refreshBase();
    }

    // clearItems() {
    //     while (this.items.length > 0) {
    //         this.items.pop();
    //     }
    // }

    @Emit("refreshBasePois") // notify parent component
    private refreshBase() {

    }
}